import { useEffect } from "react";
import { useSelector } from "react-redux";
import Accordion from "react-bootstrap/esm/Accordion";
import Card from "react-bootstrap/esm/Card";
import { useAppDispatch, RootState } from "../../../redux/store";
import { retrieveAccordion } from "../../../redux/slice/accordion-slice";

const AccordionRegisteration = (props: { path: string }) => {
  const dispatch = useAppDispatch();
  const { AccordionData: AccordionRegisterData } = useSelector((state: RootState) => state.Accordion);

  useEffect(() => {
    dispatch(retrieveAccordion(`${props.path}%2FRegister-Items`));
  }, [dispatch])

  return (
    <>
      <AccordionStyles />
      {AccordionRegisterData[0]?.data.length > 0 &&
        <div className="container">
          <Accordion alwaysOpen flush className="convergence convergence-primary">
            {AccordionRegisterData[0]?.data?.map((item, index) => {
              return <Card>
                <Accordion.Item eventKey={index.toString()} key={index}>
                  <Card.Header>
                    <Accordion.Header className="btn btn-block heading">
                      <span className="heading"><b dangerouslySetInnerHTML={{ __html: item.name }}></b>
                        <i aria-hidden="true" className="fa fa-angle-double-down" id="fa-angle-arrow"></i></span>
                    </Accordion.Header>
                  </Card.Header>
                  <Accordion.Body dangerouslySetInnerHTML={{ __html: item.description }}></Accordion.Body>
                </Accordion.Item>
              </Card>
            })}
          </Accordion>
          <div>&nbsp;</div>
        </div>}
    </>
  )
};

const AccordionStyles = () => {
  return (
    <>
      <style>
        {`
        .accordion-item .heading { float: left; white-space: break-spaces; color: inherit;}
        .convergence .accordion-button{
          font-size: 1rem;
        }
        .accordion-button:not(:disabled):not(.disabled):active, .accordion-button:not(:disabled):not(.disabled).active{
          color: #186DB4;
          background-color: #fff;
          border-color: #186DB4;
        }
        .table{
          margin-top: 0;
          font-size: 1rem
        }
        .accordion .card{
          margin-top: 0;
          margin-bottom: 0;
        }
        .convergence .accordion-button{
          font-weight: 700;
        }
        .lead{
          margin-bottom: 0;
        }
        .table td, th{
          margin-top: 0;
          font-size: 1rem;
          padding: 0.75rem !important;
        }
        .accordion-item .card-header{
          width: 100%;
          display: flex
        }
        .card-body{
          padding: 1.25rem;
        }
      `}
      </style>
    </>
    )
}

export default AccordionRegisteration;